<template>
	<div class="down">
		<div class="downSub" :style="{'min-height':screeHeight+'px'}">
			<div class="" style="">
                <div style="height:0.625rem"></div>
				<div class="title" @click="goIndex">
					<div>Tiger777</div>
				</div>
			</div>
			<div class="contact"><div>Contact us</div><i class="el-icon-s-comment"></i><div>for information</div></div>
			<div class="area-cont">
				<div class="area" @click="goArea(index)" v-for="(item,index) in areaList" :key="index">
					<img class="donw-img" src="../assets/index/tigerLogo.png" alt=""/>
					<div class="area-text">{{item.area}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
                screeHeight: 0,    // 屏幕高
				areaList:[
					{
						area:'Malaysia'
					},
					{
						area:'Hongkong'
					},
					{
						area:'Indonesia'
					},
					{
						area:'Thailand'
					},
					{
						area:'Brazil'
					},
					{
						area:'India'
					},
				]
			}
		},
		created() {
			this.minHeight()
		},
		mounted() {
			document.addEventListener("click",(e)=>{
				// console.log('e',e.target.className)
				if(e.target.className == "downSub"){
				this.$router.push('/down')
				}
			})
		},
		methods:{
			minHeight(){
				 this.screeHeight= document.documentElement.clientHeight
				// console.log('this.screeHeight',this.screeHeight)
			},
			goIndex(){
				this.$router.push('/down')
			},
			goArea(index){
				if(index==0){
					window.location.href = 'https://dl.tiger777.com/'
				}
				if(index==1){
					window.location.href = 'https://hk.tiger777.com/'
				}
				if(index==2){
					window.location.href = 'https://id.tiger777.com/'
				}
				if(index==3){
					window.location.href = 'https://th.tiger777.com'
				}
				if(index==4){
					window.location.href = 'https://br.tiger777.com'
				}
				if(index==5){
					window.location.href = 'https://in.tiger777.com'
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.downSub{
		background-color: #000000;
	}
	.title{
		border: 0.0625rem solid #2196F3;
		background: linear-gradient(to right bottom, #2196F3 50%, #1c80d0 50%);
		text-align: center;
		border-radius: 0.5rem;
		margin: 0.3125rem 1.25rem;
		height: 3.125rem;
		line-height: 3.125rem;
		color: white;
		font-size: 1.25rem;
	}
	.contact{
		display: flex;
		flex-direction: row;
		text-align: center;
		justify-content: center;
		margin: 1.25rem 0;
		font-size: 1.25rem;
		color: white;
	}
    .el-icon-s-comment{
        color: rgb(235, 12, 23);
        font-size: 1.5625rem;
        margin: 0 0.3125rem;
    }
	.area-cont{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		margin:0 1.25rem;
	}
	.area{
		width: 9.375rem;
		border: 0.0625rem solid #ffaaff;
		border-bottom: 0.125rem solid #df95df;
		text-align: center;
		background-color: rgb(248, 248, 248);
		border-radius: 0.3125rem;
		margin-bottom: 1.25rem;
		box-shadow: 0.3125rem 0.3125rem 0.3125rem #888888;
	}
	.donw-img{
		width: 9.375rem;
		height: 6.25rem;
		margin-top: 0.5rem;
	}
	.area-text{
		font-weight: 600;
		color: #3b3b3b;
		margin-bottom: 0.5rem;
        font-size: 1rem;
	}
</style>
